import { useEffect } from 'react'
import { useFlag } from '@unleash/proxy-client-react'

export const useHotjar = () => {
  const hotjar_manager_web = useFlag('hotjar_manager_web')
  useEffect(() => {
    if (!hotjar_manager_web) return

    const script = document.createElement('script')
    script.innerHTML = `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${process.env.REACT_APP_HOTJAR_ID},hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `
    document.head.appendChild(script)

    return () => {
      document.head.removeChild(script)
    }
  }, [hotjar_manager_web])

  return null
}
